import { Component } from '@angular/core';

@Component({
    selector: 'nrv-footer',
    templateUrl: './footer.component.html',
})
export class FooterComponent {}
